<template>
    <div class="columns is-multiline is-desktop">
        <div :class="columnClass" v-for="laptop in laptops" :key="laptop.id">
            <ProductCard :laptop="laptop" :key="laptop.id" :awaiting="awaiting"/>
        </div>
    </div>
</template>
<script>
    import ProductCard from './ProductCard2'

    export default {
        name: "ProductsGrid2",
        components: {ProductCard},
        props: {
            laptops: Array,
            columnWidth: Number,
            awaiting: Boolean
        },
        data() {
            return {
                focusedId: undefined,
                columnClass: ['column', 'is-' + this.columnWidth],
            }
        },
    }
</script>
